import script from "./H1Text.vue?vue&type=script&setup=true&lang=js"
export * from "./H1Text.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__